import { render } from "./InvitesPage.vue?vue&type=template&id=b2555232&scoped=true"
import script from "./InvitesPage.vue?vue&type=script&lang=js"
export * from "./InvitesPage.vue?vue&type=script&lang=js"

import "./InvitesPage.vue?vue&type=style&index=0&id=b2555232&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2555232"]])

export default __exports__